import { atom } from 'jotai';

export const selectedAnswerAtom = atom<string>('');
